import { api, getAllPages } from "./client";
import type {
  DataSource,
  CreateDataSourceRequest,
  CreateDataSourceSnapshotRequest,
  DataSourcePreviewRequest,
  DataSourcePreviewResponse,
  DataSourceSnapshot,
} from "@/types/widget";

export const getDataSources = () =>
  getAllPages<DataSource>("/v1/datasources");

export const getDataSource = (id: string) =>
  api.get<DataSource>(`/v1/datasources/${id}`);

export const createDataSource = (
  data: CreateDataSourceRequest,
  options?: { serviceId?: string }
) =>
  api.post<{ id: string }>("/v1/datasources", data, {
    serviceId: options?.serviceId,
  });

export const updateDataSource = (id: string, data: CreateDataSourceRequest) =>
  api.patch<{ id: string }>(`/v1/datasources/${id}`, data);

export const deleteDataSource = (id: string) =>
  api.delete<{ id: string }>(`/v1/datasources/${id}`);

export const previewDataSource = (
  data: DataSourcePreviewRequest,
  options?: { serviceId?: string }
) =>
  api.post<DataSourcePreviewResponse>("/v1/datasources/preview", data, {
    serviceId: options?.serviceId,
  });

export const getDataSourceSnapshot = (
  dataSourceId: string,
  customerUserId: string,
  options?: { serviceId?: string }
) =>
  api.get<DataSourceSnapshot>(
    `/v1/datasources/${dataSourceId}/snapshots`,
    { params: { user_id: customerUserId }, serviceId: options?.serviceId }
  );

export const createDataSourceSnapshot = (
  dataSourceId: string,
  data: CreateDataSourceSnapshotRequest,
  options?: { serviceId?: string }
) =>
  api.post<DataSourceSnapshot>(
    `/v1/datasources/${dataSourceId}/snapshots`,
    data,
    { serviceId: options?.serviceId }
  );
